import React from 'react';
import { LaptopIcon } from 'lucide-react';
import { TestimonialCard } from './TestimonialCard';
import { testimonials } from '../data/testimonials';
export function Testimonials() {
  return <section aria-label="Customer stories" className="bg-transparent" data-id="element-265" data-mp="3fz5ndvvjzgfq">
      <div className="mx-auto max-w-6xl px-5 py-10" style={{
      paddingTop: "9px",
      paddingBottom: "22px"
    }} data-id="element-266" data-mp="3fxb5yrjhq6ge">
        <h2 className="text-center font-display text-2xl font-black text-plum sm:text-3xl" data-id="element-267" data-mp="36yzgisud1epj">
          💬 What a better proposal process can help you do
        </h2>
        <p className="mx-auto mt-3 max-w-2xl text-center text-base text-plum/65" data-id="element-268" data-mp="31yl4z0tjvmmr">
          A clearer proposal workflow can make it easier to organize your work and communicate expectations with clients.
        </p>
        <div className="mt-8 grid w-full grid-cols-1 gap-5 md:grid-cols-3 md:gap-6" data-id="element-269" data-mp="2s3t5tskbkrpv">
          {testimonials.map((t, i) => <TestimonialCard key={t.title} testimonial={t} delay={i * 0.06} data-id="element-270" data-mp="qac22zzb8b0e" data-mpi={i} />)}
        </div>

        <div className="mx-auto mt-10 grid max-w-4xl gap-6 rounded-2xl bg-plum p-6 text-white sm:grid-cols-[auto,1fr] sm:p-8" data-id="element-271" data-mp="q8iwzp4chyui">
          <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-grape text-white shadow-[0_0_24px_rgba(46,197,255,0.55)]" data-id="element-272" data-mp="m5kmoqccuxdh">
            <LaptopIcon className="h-6 w-6" aria-hidden="true" data-id="element-273" data-mp="79lelfp8wx8c" />
          </span>
          <div data-id="element-274" data-mp="c7mwvyeuksir">
            <h3 className="font-display text-lg font-black sm:text-xl" data-id="element-275" data-mp="c73r1g2h1ul3">Access your digital system wherever you work</h3>
            <p className="mt-2 text-sm leading-relaxed text-white/75" data-id="element-276" data-mp="zysd4eop9mtl">
              Use your digital materials with compatible AI assistants and adapt the prompts to your service, your clients,
              and the way you manage projects. Whether you prepare design proposals, website development offers, copywriting
              projects, marketing services, consulting engagements, or other freelance work, the system is designed to be
              customized to your needs.
            </p>
            <p className="mt-3 text-sm font-semibold text-grape-soft" data-id="element-277" data-mp="1nnv44d584s0r">
              You remain in control of the final proposal. AI can help organize and draft content, while your professional
              judgment determines what is accurate and ready to send.
            </p>
          </div>
        </div>
      </div>
    </section>;
}